export default "__VITE_ASSET__BCdOTg4X__"